import { useLocation } from 'react-router-dom'

/**
 * Utility hook to check if the current route matches the given route.
 * @param {string} route - The route to compare with the current location.
 * @param {boolean} [exact=false] - Whether to check for an exact match or not.
 * @returns {boolean} - True if the current route matches the given route.
 */
export const useIsCurrentRoute = (route, exact = false) => {
    const location = useLocation()
    return exact ? location.pathname === route : location.pathname.startsWith(route)
}
